import { API_URL } from "@/composables/useApi";

export const getImageUrl = (fileId: string) => {
    return `${API_URL}file/${fileId}`
}